module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-zip-fill-9c148332.svg";